import * as SubframeCore from "@subframe/core";

export const twClassNames = SubframeCore.twClassNames;
